import 'firebase'

import {
  CREATE_SITE_ERROR,
  CREATE_SITE_SUCCESS,
  DELETE_SITE,
  DELETE_SITE_SUCCESS,
  LOAD_SITES_SUCCESS,
  UNLOAD_SITES_SUCCESS,
  SET_CURRENT_SITE,
  UPDATE_SITE_ERROR,
  UPDATE_SITE_SUCCESS,
  START_PARSING,
  NEW_API_KEY_ADDED,
  API_KEY_DELETE,
} from './action-types'

import { FirebaseList, firebaseDb } from 'modules/firebase'
import Site from 'modules/sites/site'
import { actions as queuesActions } from 'modules/queues'
import { getFirstAccount } from 'modules/accounts'
import { getCurrentSiteId } from 'modules/sites/selectors'


const siteList = new FirebaseList(Site)

export function loadSites() {
  return (dispatch, getState) => {
    const account = getFirstAccount(getState())
    if (!account) { return }
    siteList.path = `/sites/${account.key}`
    siteList.subscribe(dispatch, {
      onLoad: siteSuccessListener(LOAD_SITES_SUCCESS, account.key),
      onChange: siteSuccessListener(UPDATE_SITE_SUCCESS, account.key),
      onRemove: siteSuccessListener(DELETE_SITE_SUCCESS, account.key),
      onAdd: siteSuccessListener(CREATE_SITE_SUCCESS, account.key),
    })
  }
}

export function unloadSites() {
  siteList.unsubscribe()
  return {
    type: UNLOAD_SITES_SUCCESS,
  }
}

export function createSite(site) {
  return dispatch => {
    siteList.push(site)
      .catch(error => dispatch(onSiteError(error, CREATE_SITE_ERROR)))
  }
}

export function deleteSite(site) {
  return { type: DELETE_SITE, payload: site }
}

export function updateSite(site, changes) {
  return dispatch => {
    siteList.update(site.key, changes)
      .catch(error => dispatch(onSiteError(error, UPDATE_SITE_ERROR)))
  }
}

/**
 * Sets currentSite state from given key
 * @param {string} site - site key
 * @returns {function} Thunk
 */
export function setCurrentSite(site) {
  return (dispatch, getState) => {
    const currentSiteId = getCurrentSiteId(getState());

    if (currentSiteId !== site) {
      dispatch({
        type: SET_CURRENT_SITE,
        payload: site || null,
      })
    }
  }
}

export function startProcess(siteId) {
  return dispatch => {
    const queueId = firebaseDb.ref(`/queues/${siteId}`).push().key;
    dispatch({ type: START_PARSING, payload: { siteId: siteId, queueId } });
  }
}

function siteSuccessListener(type, account) {
  return result => ({
    type: type,
    account,
    payload: result,
  })
}

function onSiteError(error, type) {
  return {
    type: type,
    payload: error,
  }
}

/** API Keys  actions */

export const generateKey = (account, siteId) => {
  return dispatch => {
    const newKey = firebaseDb.ref(`sites/${account.key}/${siteId}/apiKeys`).push(true).key
    dispatch({ type: NEW_API_KEY_ADDED, payload: { key: newKey, accountId: account.key, siteId } })
  }
}

export const deleteKey = (account, siteId, key) => {
  return dispatch => {
    firebaseDb.ref(`sites/${account.key}/${siteId}/apiKeys/${key}`).remove()
      .then(() => dispatch({ type: API_KEY_DELETE, payload: { key: key, accountId: account.key, siteId } }))
  }
}



// WEBPACK FOOTER //
// ./src/modules/sites/actions.js